export default __webpack_public_path__ + "static/media/deer-creek.b3530c73.jpg";